/* eslint-disable max-len */
/* methods used in multiple components */

const Helpers = {
  time() {
    const now = new Date()
    const hour = now.getHours()
    const min = now.getMinutes()
    return `${hour}:${min}`
  },

  truncateString(str, limit) {
    if (str?.length > limit) {
      return str.slice(0, limit) + '...'
    } else {
      return str
    }
  },

  dragElement(elmnt) {
    let pos1 = 0; let pos2 = 0; let pos3 = 0; let pos4 = 0;
    if (document.getElementById(elmnt.id + 'header')) {
      // if present, the header is where you move the DIV from:
      document.getElementById(elmnt.id + 'header').onmousedown = dragMouseDown;
    } else {
      // otherwise, move the DIV from anywhere inside the DIV:
      elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      elmnt.style.top = (elmnt.offsetTop - pos2) + 'px';
      elmnt.style.left = (elmnt.offsetLeft - pos1) + 'px';
    }

    function closeDragElement() {
      // stop moving when mouse button is released:
      document.onmouseup = null;
      document.onmousemove = null;
    }
  },

  async fetchPostJson(url, data, headers = {}) {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    const headerKeys = Object.keys(headers)
    if (headerKeys?.length > 0) {
      headerKeys.forEach((key) => {
        myHeaders.append(key, headers[key])
      })
    }
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(data),
      redirect: 'follow',
    }

    const response = await fetch(url, requestOptions)
    // parses JSON response into native JavaScript objects
    return response.json()
  },

  async fetchPostPDF(url, data, headers = {}) {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    const headerKeys = Object.keys(headers)
    if (headerKeys?.length > 0) {
      headerKeys.forEach((key) => {
        myHeaders.append(key, headers[key])
      })
    }
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(data),
      redirect: 'follow',
    }

    const response = await fetch(url, requestOptions)
    // parses JSON response into native JavaScript objects
    return response
  },

  calculateTimeDifference(timestamp1, timestamp2) {
    // Check if both inputs are valid timestamps
    if (isNaN(timestamp1) || isNaN(timestamp2)) {
      return
      // throw new Error('Invalid timestamp')
    }

    // Calculate the absolute difference between the two timestamps
    const timeDifference = Math.abs(timestamp1 - timestamp2)

    // Convert the time difference from milliseconds to minutes
    const minutes = Math.round(timeDifference / (1000 * 60))

    return minutes
  },

  copyToClipBoard(copyText, successCb) {
    navigator.permissions.query({name: 'clipboard-write'})
        .then((result) => {
          if (result.state === 'granted' || result.state === 'prompt') {
            /* write to the clipboard */
            navigator.clipboard.writeText(copyText)
                .then(() => {
                  /* clipboard successfully set */
                  successCb()
                })
                .catch(clipboardCopyFallback)
          } else {
            clipboardCopyFallback()
          }
        })
        .catch(clipboardCopyFallback)

    function clipboardCopyFallback() {
      /*
        Necessary for Safari/Firefox or situtations without clipboard access:
        -Create invisible DOM element that contains copyText
        -Focus/select DOM element
        -copy content of DOM element
        -remove DOM element
      */
      const textArea = document.createElement('textarea')
      textArea.value = copyText

      // Avoid scrolling to bottom
      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.position = 'fixed'

      // create DOM element, focus, select DOM element
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      // copy content of DOM element
      try {
        /*
          MDN says document.execCommand is deprecated
          but at the time of writing this (Feb 2023),
          it has wide browser support
        */
        document.execCommand('copy')
        successCb()
      } catch (err) {
        console.error('Unable to copy to clipboard: ', err)
      }
      // remove DOM element
      document.body.removeChild(textArea);
    }
  },

  timeStampToDate(timestamp) {
    const dateObj = new Date(timestamp)
    return (
      dateObj.getMonth() + 1 +
      '/' + dateObj.getDate() +
      '/' + dateObj.getFullYear()
    )
  },

  timeStampToTime(timestamp) {
    const dateObj = new Date(timestamp)
    const hours = dateObj.getHours().toString()
    const minutes = dateObj.getMinutes().toString()
    const formattedHours = hours.length === 2 ? hours : '0' + hours
    const formattedMinutes = minutes.length === 2 ? minutes : '0' + minutes
    return (
      `${formattedHours}:${formattedMinutes}`
    )
  },

  timeStampToDateAndTime(timestamp) {
    return `${this.timeStampToDate(timestamp)} ${this.timeStampToTime(timestamp)}`
  },

  formatDate(str) {
    if (str) {
      const dashB = str.slice(5, str.length) + '/' + str.slice(0, 4)
      return dashB.replace('-', '/')
    } else {
      return ''
    }
  },

  getFileTypeFromName(fileName) {
    const extension = fileName.split('.').reverse()[0]
    if (extension === 'pdf') {
      return 'application/pdf'
    } else {
      return `image/${extension}`
    }
  },

  /* Used to trigger callback after typing has stopped for pause length */
  toggleTyping(timeOfType, callback, pauseLength = 2000) {
    setTimeout(() => {
      const now = Date.now()
      if ((now - timeOfType) >= pauseLength) {
        callback()
      }
    }, pauseLength);
    return false
  },

  fileSizeFormat(fileSize) {
    let size = 1000000000
    for (size = 1000000000; size > 1000; size = size / 1000) {
      if (fileSize > size) {
        break
      }
    }
    const suffix = size >= 1000000000 ? 'GB' : size >= 1000000 ? 'MB' : 'KB'
    return `${Math.round((fileSize / size) * 10) / 10} ${suffix}`
  },

  fileTypeFormat(fileType) {
    if (!fileType) {
      return 'Folder'
    } else if (fileType.includes('image')) {
      return 'Image'
    } else if (fileType.includes('audio')) {
      return 'Audio'
    } else if (fileType.includes('video')) {
      return 'Video'
    } else {
      return 'Document'
    }
  },

  fileTypeFormatFromName(fileName) {
    // list of file extensions from RikY-Code
    if (!fileName.includes('.') || [
      '.zip',
      '.rar',
      '.7z',
      '.tar',
      '.gz',
      '.bz2',
      '.xz',
      '.lzma',
      '.lz',
      '.arj',
      '.cab',
      '.lha',
      '.lzh',
      '.iso',
      '.nrg',
      '.mzip',
      '.udz',
      '.zipx',
      '.cpt',
    ].some((fileExtension) => fileName.includes(fileExtension))) {
      return 'Folder'
    } else if ([
      '.jpg',
      '.jpeg',
      '.png',
      '.gif',
      '.bmp',
      '.tiff',
      '.tif',
      '.psd',
      '.ico',
      '.cur',
      '.svg',
      '.webp',
      '.heif',
      '.heic',
      '.cr2',
      '.nef',
      '.orf',
      '.arw',
      '.sr2',
      '.dng',
      '.crw',
      '.mrw',
      '.pef',
      '.k25',
      '.k26',
      '.dcr',
      '.drf',
      '.kdc',
    ].some((fileExtension) => fileName.includes(fileExtension))) {
      return 'Image'
    } else if ([
      '.mp3',
      '.wav',
      '.aac',
      '.flac',
      '.alac',
      '.ogg',
      '.m4a',
      '.wma',
      '.aiff',
      '.ac3',
      '.dts',
      '.au',
      '.aifc',
      '.mp2',
      '.vorbis',
    ].some((fileExtension) => fileName.includes(fileExtension))) {
      return 'Audio'
    } else if ([
      '.mp4',
      '.avi',
      '.mov',
      '.wmv',
      '.flv',
      '.mkv',
      '.webm',
      '.m4v',
      '.3gp',
      '.ts',
      '.ogg',
      '.ogv',
      '.divx',
      '.xvid',
      '.rmvb',
    ].some((fileExtension) => fileName.includes(fileExtension))) {
      return 'Video'
    } else {
      return 'Document'
    }
  },

  // way to set value in an object at the specific path
  setObjValueAtPath(obj, value, path) {
    if (obj && Object.keys(obj).length) {
      let i;
      for (i = 0; i < path.length - 1; i++) {
        obj = obj[path[i]];
      }
      // console.log('path[i]', path[i])
      obj[path[i]] = value;
    }
  },

  // get a value from a specific path in an object
  getObjValueFromPath(obj, path) {
    let i;
    for (i = 0; i < path.length - 1; i++) {
      obj = obj?.[path[i]];
    }
    return obj?.[path[i]] || obj;
  },

  removeTextSelection() {
    if (document.selection) {
      document.selection.empty()
    }
    if (window.getSelection) {
      const sel = window.getSelection()
      sel.removeAllRanges()
    }
  },

  removeDuplicateTasks(tasks) {
    /* tasks are stored under an id like taskname_timestamp
       Iterate through starting with the latest potential duplicate and only store
       a task if there isn't already one of the same task name
    */
    if (tasks) {
      // usees taskId: task
      const uniqueTasks = {}
      // uses taskName: task
      const uniqueTasksHash = {}
      // reverse because the latest potential duplicate will be at the end
      const taskIds = Object.keys(tasks).reverse()
      taskIds.forEach((taskId) => {
        const taskIdArr = taskId.split('_')
        // eslint-disable-next-line no-unused-vars
        const taskTime = taskIdArr.pop()
        // join for potential task names with underscore
        const taskName = taskIdArr.join('')
        // if task isn't a repetition or it has no response yet
        if (!uniqueTasksHash.hasOwnProperty(taskName) || uniqueTasksHash[taskName]?.status !=='finished') {
          uniqueTasksHash[taskName] = tasks[taskId]
          uniqueTasks[taskId] = tasks[taskId]
        }
      })
      return uniqueTasks
    } else {
      console.log('No tasks')
      return {}
    }
  },

  async getFileFromURL(url, name) {
    let realUrl = url
    if (!url.includes('https')) {
      realUrl = await this.fetchPostJson(process.env.REACT_APP_FILE_URL, {path: url})
          .then((response) => {
            return response?.url
          })
          .catch((e) => {
            console.log(url, e)
            return null
          })
    }
    if (!realUrl) {
      return null
    }
    const response = await fetch(realUrl)
        .then((resp) => {
          return resp
        })
        .catch((err) => {
          console.log(realUrl, err)
          return null
        })
    const blob = await response?.blob() || null
    return blob ? new File([blob], name, {type: blob.type}) : null
  },

  snakeCaseToDisplay(str) {
    if (str && str.length > 0) {
      let result = str.charAt(0).toUpperCase() + str.slice(1)
      while (result.includes('_')) {
        const indexOfFirst_ = result.indexOf('_')
        result = result.slice(0, indexOfFirst_) + ' ' + result.charAt(indexOfFirst_ + 1).toUpperCase() + result.slice(indexOfFirst_ + 2)
      }
      return result
    } else {
      return ''
    }
  },

  isStringJSON(string) {
    try {
      JSON.parse(string);
    } catch (e) {
      return false;
    }
    return true;
  },

  formatTimeDelta(timeDelta) {
    const deltaHour = Math.floor(timeDelta / (60*60*1000))
    const deltaRest1 = timeDelta - (60*60*1000*deltaHour)
    const deltaMinutes = Math.floor(deltaRest1 / (60*1000))
    const deltaRest2 = deltaRest1 - (60*1000*deltaMinutes)
    const deltaSeconds = Math.floor((deltaRest2/1000)*10000)/10000
    const timeArr = [[deltaHour, 'hours'], [deltaMinutes, 'minutes'], [deltaSeconds, 'seconds']].filter((arr) => arr[0] > 0)
    return timeArr.map((arr) => `${arr[0]} ${arr[1]}`).join(' ')
  },

  resetTimeValue(string, time) {
    const newString = string.
        replaceAll(
            /(_|\b)("?)987987(\w+)987987\2|(_|\b)("?)987987(\w+)988000\2|(_|\b)("?)987987(\w+)987980\2|(_|\b)("?)987987(\w+)987988\2/gi,
            (match, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12) => {
              const innerValue = p3 || p6 || p9 || p12
              // console.log(JSON.stringify([p1, p2, p3, p4, p5, p6]))
              // console.log(innerValue)
              // if (!innerValue || (innerValue > 807500)) {
              //   console.log(match, time, innerValue, parseInt(innerValue), time + parseInt(innerValue))
              // }
              if (p1) {
                return `_${parseInt(time) + parseInt(innerValue)}`
              } else {
                return parseInt(time) + parseInt(innerValue)
              }
            },
        )
    return newString
  },

  // way to set value in an object at the specific path
  setObjValueAtPath(obj, value, path) {
    if (obj && Object.keys(obj).length) {
      let i;
      for (i = 0; i < path.length - 1; i++) {
        if (obj?.[path[i]] === undefined) {
          obj[path[i]] = {}
        }
        obj = obj[path[i]];
      }
      // console.log('path[i]', path[i])
      obj[path[i]] = value;
    }
  },

  // get a value from a specific path in an object
  getObjValueFromPath(obj, path) {
    let i;
    for (i = 0; i < path.length - 1; i++) {
      obj = obj?.[path[i]];
    }
    return obj?.[path[i]];
  },
}

export default Helpers
